import { useEffect, useState } from 'react'

interface IPhoneStatusBarProps {
  carrierName?: string
}

export function IPhoneStatusBar({ carrierName: _carrierName }: IPhoneStatusBarProps) {
  const [time, setTime] = useState(() => {
    const now = new Date()
    return now.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  })

  useEffect(() => {
    const updateTime = () => {
      const now = new Date()
      setTime(now.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }))
    }

    // Update immediately and then every minute
    const interval = setInterval(updateTime, 60000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="absolute top-0 left-0 right-0 h-[48px] flex items-center justify-between px-4 pt-2 text-white text-[12px] font-semibold z-20 pointer-events-none">
      {/* Left: Time */}
      <span className="min-w-[48px] ml-2">{time}</span>

      {/* Center: Space for Dynamic Island */}
      <div className="flex-1 max-w-[105px]" />

      {/* Right: Icons */}
      <div className="flex items-center gap-[3px] min-w-[58px] justify-end mr-2">
        {/* Signal */}
        <SignalIcon className="h-[10px] w-[15px]" />
        {/* WiFi */}
        <WifiIcon className="h-[10px] w-[13px]" />
        {/* Battery */}
        <BatteryIcon className="h-[10px] w-[22px]" />
      </div>
    </div>
  )
}

function SignalIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 17 10.7" fill="currentColor">
      <path d="M15.5 10.7h1.5V0h-1.5zm-4 0H13V2.7h-1.5zm-4 0H9V5.3H7.5zm-4 0H5V8H3.5zM0 10.7h1.5V10H0z" />
    </svg>
  )
}

function WifiIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 15.4 11" fill="currentColor">
      <path d="M7.7 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-2.9-4.2 1.4 1.4A2.6 2.6 0 0 1 7.7 7.5a2.6 2.6 0 0 1 1.5.7l1.4-1.4a4.6 4.6 0 0 0-5.8 0zm-2.9-2.9L3.3 5.3a5.5 5.5 0 0 1 8.8 0l1.4-1.4a7.5 7.5 0 0 0-11.6 0zM0 1.9l1.4 1.4a8.5 8.5 0 0 1 12.6 0l1.4-1.4C10.8-.2 4.6-.2 0 1.9z" />
    </svg>
  )
}

function BatteryIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 25 12" fill="currentColor">
      <rect
        x="0.5"
        y="0.5"
        width="21"
        height="11"
        rx="2.5"
        stroke="currentColor"
        fill="none"
        strokeWidth="1"
        opacity="0.35"
      />
      <rect x="23" y="3.5" width="2" height="5" rx="1" opacity="0.4" />
      <rect x="2" y="2" width="17" height="8" rx="1.5" />
    </svg>
  )
}
